import V3Adapter from './v3';

export default class IpadConfigAdapter extends V3Adapter {}
